<template>
  <div class="hello">
    <h1>Fournier's SI</h1>
    <p class="subtitle">Fournier's Gangrene Severity Index</p>
    <div class="action-bar">
      <span class="score" :class="{danger: score >= 9}">{{score}}</span>
      <img src="../assets/refresh.svg" @click="refresh" class="refresh animate__animated">
    </div>
    <ParamButton v-for="(param, index) in store.params"
      :key="param.name" :label="param.name" :paramindex="index"
      :row="index+3"  @click="navigateTo(index)" />
    <Select v-if="showSelect" :index="index" @chosed="showSelect=false"/>
  </div>
</template>

<script>

import ParamButton from "../components/ParamButton"
import Select from "../components/Select"
import store from "../assets/store"

export default {
  name: 'Fournier',
  components: {
    ParamButton, Select
  },
  data() {
    return {
      store: store,
      showSelect: false,
      index: 0
    };
  },
  computed: {
    score() {
      let buf = 0;
      for (const param of this.store.params) {
        if (param.chosen >= 0) {
            buf += param.values[param.chosen].mod;
        }
      }
      return buf;
    }
  },
  watch: {
    showSelect: function (newv) {
      if (newv) {
        document.querySelector('body').classList.add('stop-scroll')
      }  else {
        document.querySelector('body').classList.remove('stop-scroll')
      }
    }
  },
  methods: {
    navigateTo(index) {
      console.log(index),
      this.index = index
      this.showSelect = true
    },
    refresh() {
      const animateCSS = (element, animation, prefix = 'animate__') =>
        // We create a Promise and return it
        new Promise((resolve, reject) => {
          const animationName = `${prefix}${animation}`;
          const node = document.querySelector(element);

          node.classList.add(`${prefix}animated`, animationName);

          // When the animation ends, we clean the classes and resolve the Promise
          function handleAnimationEnd() {
            node.classList.remove(`${prefix}animated`, animationName);
            node.removeEventListener('animationend', handleAnimationEnd);

            resolve('Animation ended');
          }

          node.addEventListener('animationend', handleAnimationEnd);

          console.log(reject)
      });

      animateCSS('.refresh', 'rotateIn');

      for (let param of this.store.params) {
          param.chosen = -1;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .title-panel {
        vertical-align: top;
        font-size: 20;
        margin: 15;
    }

    .description-label {
        margin-bottom: 15;
    }

    .refresh {
      height: 30px;
      cursor: pointer;
    }

    .danger {
        color: red;
    }

    .action-bar {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
    }

    .score {
      text-align: left;
      margin:10px;
      font-size: 40px;
    }

    h1 {
      text-align: left;
      margin: 10px;
    }

    .subtitle {
      text-align: left;
      margin: 10px;
    }
</style>
